'use client';
import React from 'react';
import { CheckoutProvider } from '@stripe/react-stripe-js/checkout';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY ?? ''
);

const StripeCheckoutProvider = ({
  clientSecret,
  children
}: {
  clientSecret: string;
  children: React.ReactNode;
}) => {
  return (
    <CheckoutProvider
      stripe={stripePromise}
      options={{
        elementsOptions: {
          fonts: [
            {
              cssSrc:
                'https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap'
            }
          ],
          appearance: {
            theme: 'flat',
            variables: {
              colorPrimary: '#F8C15D',
              fontFamily: '"Oswald", sans-serif',
              borderRadius: '8px'
            }
          }
        },
        clientSecret: clientSecret
      }}
    >
      {children}
    </CheckoutProvider>
  );
};

export default StripeCheckoutProvider;
